import s from '../allservices.jsx'
import { ToastContainer, toast } from 'react-toastify';

const getUseridInfoService = (actionCallback, userId) => {
    let token = "Token " + localStorage.getItem('token')

    fetch(s.userid_info + "/" + userId, {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
        })
    })
        .then(res => {

            if (res.status === 200) {
                if (localStorage.getItem('userIdToast') === 'first') {
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('userIdToast', 'second')
                }
                res.json().then(json => actionCallback(json, "success"))
            } 
            else if(res.status === 401){
                actionCallback("401", "sessionout")
            }
            else {
                if (localStorage.getItem('userIdToast') === 'first') {
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                // localStorage.setItem('userIdToast', 'second')
            }
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getUseridInfoService;


// WEBPACK FOOTER //
// ./src/services/components/userid_info.jsx